import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 md:gap-5">
      {categories.map((category) => (
        <a
          key={category.key}
          href={category.url}
          target="_blank"
          rel="noopener nofollow"
          className="group flex flex-col gap-3"
        >
          <div className="relative aspect-square w-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <img
              src={category.image}
              alt={t(category.key)}
              title={`${t(category.key)} Basetao`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <span className="truncate text-center text-sm font-medium text-foreground-900">
            {t(category.key)}
          </span>
        </a>
      ))}
    </div>
  );
}